import { Mapper } from "../../../../base/utils/mapper";
import { ConfirmationResponseEntity } from "../entities/confirmation-response.entity";
import { ConfirmationResponseModel } from '../../../../domain/models/consult/confirmation-response.model';


export class ConfirmationImplementationRepositoryMapper extends Mapper<ConfirmationResponseEntity, ConfirmationResponseModel> {
    mapFrom(param: ConfirmationResponseEntity): ConfirmationResponseModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: ConfirmationResponseModel): ConfirmationResponseEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}